import { Button, Form, Popconfirm, Space, Table } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { deleteLeavePolicy, loadAllLeavePolicy, updateLeavePolicy } from '../../redux/rtk/features/leavePolicy/leavePolicySlice';
import EditLeavePolicyModal from './editLeavePolicy';


const LeavePolicyTable = () => {
  const { list, loading } = useSelector((state) => state.leavePolicy);
  console.log("list", list);

  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [selectedPolicy, setSelectedPolicy] = useState(null);


  useEffect(() => {
    dispatch(loadAllLeavePolicy());
  }, [dispatch]);

  const handleDelete = (id) => {
    dispatch(deleteLeavePolicy(id))
      .then(() => {
        // message.success('Leave Policy deleted successfully');
        dispatch(loadAllLeavePolicy());
      })
      .catch((error) => {
        // message.error('Error in deleting leave policy');
      });
  };
  const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

  const handleEditClick = (record) => {
    setSelectedPolicy(record);
    setEditModalVisible(true);
  };

  const handleEditModalCancel = () => {
    setEditModalVisible(false);
    setSelectedPolicy(null);
  };

  const handleEditModalOk = (values) => {
    dispatch(updateLeavePolicy({ id: selectedPolicy.id, values }))
      .then(() => {
        setEditModalVisible(false);
        setSelectedPolicy(null);
        dispatch(loadAllLeavePolicy());
      })
      .catch((error) => {
        console.log("Error updating policy:", error);
      });
  };


  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Valid From',
      dataIndex: 'validFrom',
      key: 'validFrom',
      render: (validFrom) => validFrom ? dayjs(validFrom).format('DD-MM-YYYY') : 'N/A',

    },
    {
      title: 'Valid To',
      dataIndex: 'validTo',
      key: 'validTo',
      render: (validTo) => validTo ? dayjs(validTo).format('DD-MM-YYYY') : 'N/A',
    },
    {
      title: 'Leave Type',
      dataIndex: 'leaveType',
      key: 'leaveType',
      render: (leaveType) => leaveType ? leaveType.leaveType : 'N/A', // Safely access nested field
    },

    {
      title: 'Limit',
      dataIndex: 'limit',
      key: 'limit',
      render: (limit) => (limit ? 'Yes' : 'No'),
    },

    {
      title: 'Paid',
      dataIndex: 'paid',
      key: 'paid',
      render: (paid) => (paid ? 'Yes' : 'No'),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => handleEditClick(record)}>Edit</Button>
          <Popconfirm
            title="Are you sure you want to delete this policy?"
            onConfirm={() => handleDelete(record.key)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table columns={columns} dataSource={list ? addKeys(list) : []} />

      <EditLeavePolicyModal
        visible={editModalVisible}
        onCancel={handleEditModalCancel}
        onOk={handleEditModalOk}
        initialValues={selectedPolicy}
        leaveTypes={leaveTypes}
        loading={loading}
      />
    </>
  );
};

export default LeavePolicyTable;
